import React from 'react';
import { NavLink } from 'react-router-dom';
import './AdminSessions.css';

const sessionTabs = [
  { to: '/admin/sessions', label: 'Sessions', end: true },
  { to: '/admin/sessions/errors', label: 'Errors' },
];

const AdminSessionsNav = () => (
  <nav className="cq-admin-session-tabs" aria-label="Session monitoring navigation">
    {sessionTabs.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        end={tab.end}
        className={({ isActive }) => `cq-admin-session-tab${isActive ? ' is-active' : ''}`}
      >
        {tab.label}
      </NavLink>
    ))}
  </nav>
);

export default AdminSessionsNav;
